import routeMetadataJson from './routeMetadata.json';

export interface RouteMeta {
  title: string;
  description: string;
  /** Optional path to a 1200×630 OG image (e.g. /og/poker.png). */
  image?: string;
}

export const ROUTE_METADATA: Record<string, RouteMeta> =
  routeMetadataJson as Record<string, RouteMeta>;

/**
 * Get metadata for a path. For dynamic routes (e.g. /split-bills/abc), returns the base route metadata if available.
 */
export function getRouteMeta(pathname: string): RouteMeta | undefined {
  const normalized = pathname.endsWith('/') && pathname !== '/' ? pathname.slice(0, -1) : pathname;
  if (ROUTE_METADATA[normalized]) {
    return ROUTE_METADATA[normalized];
  }
  // Try base path for nested/dynamic routes (e.g. /split-bills/xyz -> /split-bills)
  const segments = normalized.split('/').filter(Boolean);
  while (segments.length > 0) {
    const basePath = '/' + segments.join('/');
    if (ROUTE_METADATA[basePath]) {
      return ROUTE_METADATA[basePath];
    }
    segments.pop();
  }
  return undefined;
}
